import { render, staticRenderFns } from "./SimulacionLegend.vue?vue&type=template&id=5ca74f48&scoped=true"
import script from "./SimulacionLegend.vue?vue&type=script&lang=js"
export * from "./SimulacionLegend.vue?vue&type=script&lang=js"
import style0 from "./SimulacionLegend.vue?vue&type=style&index=0&id=5ca74f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca74f48",
  null
  
)

export default component.exports